import dayjs from "dayjs"
import { useContext } from "react"
import { SidePanelContext } from "../../../../components/contexts/SidePanelContext"
import { BillGet } from "../../../../data/Types"
import { returnAddressString } from "../../../../services/functions"
import { ObjectType } from "../../../Objekte/types/types"
import { BillTypes } from "../../../../api/constants"
import { ReactComponent as EYE } from "../../../../assets/EyeICON.svg"
import { Tag } from "antd"
import HeadTableRow from "../HeadTableRow"

type BillDetailHeadType = {
    data: BillGet
    connectedOffer?: any
    setResendUri: (e: string) => void
    setMailPreviewContent: (e: string) => void
}

export default function BillDetailHead(props: BillDetailHeadType) {
    const sidePanelCon = useContext(SidePanelContext)

    return (
        <div className="flex flex-col lg:flex-row gap-4 h-fit">
            {/* Basic Information about Bill */}
            <div className="w-full min-h-fit rounded-default shadow-lg mt-6 bg-white p-4 grow">
                <HeadTableRow link={"/kunden/" + props.data?.customer_id?._id} info={"Kunde"} content={props.data?.customer_id?.customer?.name} />
                <HeadTableRow
                    link={"/objekte/" + props.data?.object_id?._id}
                    info={"Objekt"}
                    content={props.data?.object_id ? returnAddressString(props.data?.object_id as ObjectType) : "kein verknüpftes Objekt"}
                />
                <HeadTableRow info={window.innerWidth > 640 ? "ausgestellt am" : "ausgestellt"} content={dayjs(props.data.date).format("DD.MM.YYYY")} />
                <HeadTableRow info={window.innerWidth > 640 ? "Rechnungstyp" : "Typ"} content={props.data?.billType} />
                <HeadTableRow info={"Archiviert"} content={props.data?.archived ? "Ja" : "Nein"} />
                <HeadTableRow
                    link={props.data?.offer_id && "/buchhaltung/angebote/" + props.data?.offer_id}
                    info={"Angebot"}
                    content={props.data?.offer_id ? "Angebot " + props.connectedOffer?.nr : "kein verknüpftes Angebot"}
                />
                <HeadTableRow info={"Zahlungsfrist"} content={props.data.billDue + " Tage"} />
                <HeadTableRow
                    info={"Mahnungssystem"}
                    content={`nach ${props.data.reminderStartOffsetInDays} Tagen Zahlungsverzug, im Abstand von ${props.data.reminderIntervalInDays} Tagen, maximal ${props.data.maxReminders} Mahnungen`}
                />
                {(props.data.billType === BillTypes.JAHRES_RECHNUNG || props.data.billType === BillTypes.DAUER_RECHNUNG) && (
                    <HeadTableRow info={"Bezahlen bis zum"} content={props.data.billDay + ". eines Monats"} />
                )}
            </div>
            {/* Information about Mail */}
            {props.data.mailReports && props.data.mailReports.length > 0 && (
                <div className="w-full grow bg-white rounded-default shadow-lg lg:mt-6 pt-2 px-4 pb-4 ">
                    <div className="w-full h-8 flex justify-between items-center">
                        <HeadTableRow info={"Absendeversuche"} content={props.data?.mailReports?.length?.toString()} />
                    </div>
                    <div className={`overflow-y-scroll w-full ${props.data.billType !== "Rechnung" ? "h-48" : "h-40"}`}>
                        {props.data.mailReports.map((item) => (
                            <div className="flex flex-col w-full py-1 border-b relative">
                                <HeadTableRow info={"Mail versandt am"} content={dayjs(item.date).format("DD.MM.YYYY, HH:mm") + " Uhr"} />
                                <HeadTableRow
                                    info={"Empfänger"}
                                    content={item.mailReceivers?.map((itemMail: string) => itemMail + (item.mailReceivers?.indexOf(itemMail) + 1 !== item.mailReceivers.length ? ", " : ""))}
                                />
                                <div className="flex flex-wrap pt-1">
                                    {item?.version === 1 ? (
                                        item?.mailDeliverySuccess ? (
                                            <Tag color="green">Erfolgreich</Tag>
                                        ) : (
                                            <Tag color="red">Fehlgeschlagen</Tag>
                                        )
                                    ) : item?.version === 2 ? (
                                        item?.notifuseEvents?.map((event: any) => (
                                            <Tag color={"grey"}>
                                                {event.eventType === "email.sent"
                                                    ? "Versendet"
                                                    : event.eventType === "email.clicked"
                                                    ? "Angeklickt"
                                                    : event.eventType === "email.opened"
                                                    ? "Geöffnet"
                                                    : ""}
                                            </Tag>
                                        ))
                                    ) : undefined}
                                </div>
                                <EYE
                                    aria-disabled={!item.mailContent}
                                    className="hidden sm:block btn btn-outline btn-primary btn-xs absolute top-2 right-4"
                                    onClick={() => {
                                        props.setResendUri(item.resendUri)
                                        props.setMailPreviewContent(item.mailContent)
                                        sidePanelCon?.trigger(4)
                                    }}
                                />
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </div>
    )
}
